import { render, staticRenderFns } from "./AssetGalleryModal.vue?vue&type=template&id=01a8361f&"
import script from "./AssetGalleryModal.vue?vue&type=script&lang=js&"
export * from "./AssetGalleryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports